import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route, useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import TopBar from "./components/TopBar";
import Sidebar from "./components/Sidebar";
import PrivateRoute from "./components/PrivateRoute";
import Home from "./components/User/Home";
import Marques from "./components/User/Marques";
import MarquesFull from "./components/User/MarquesFull";
import ListeFournisseursMontures from "./components/User/ListeFournisseursMontures";
import ListeFournisseursVerres from "./components/User/ListeFournisseursVerres";
import ListeFournisseursLentilles from "./components/User/ListeFournisseursLentilles";
import ListeMutuelles from "./components/User/ListeMutuelles";
import FournisseurMontures from "./components/User/FournisseurMontures";
import FournisseurLentilles from "./components/User/FournisseurLentilles";
import FournisseurVerres from "./components/User/FournisseurVerres";
import Mutuelle from "./components/User/Mutuelle";
import Login from "./components/User/Login";
import SignUp from "./components/User/SignUp";
import Contact from "./components/User/Contact";
import OubliMdp from "./components/User/OubliMdp";
import MonCompte from "./components/User/MonCompte";
import AdminMutuelle from "./components/Admin/AdminMutuelle";
import AdminFournisseurMontures from "./components/Admin/AdminFournisseurMontures";
import AdminFournisseurLentilles from "./components/Admin/AdminFournisseurLentilles";
import AdminFournisseurVerres from "./components/Admin/AdminFournisseurVerres";
import AdminListeMontures from "./components/Admin/AdminListeMontures";
import AdminLogin from "./components/Admin/AdminLogin";
import AdminHome from "./components/Admin/AdminHome";
import AdminMarques from "./components/Admin/AdminMarques";
import AdminListeFournisseurs from "./components/Admin/AdminListeFournisseurs";
import AdminListeFournisseursVerres from "./components/Admin/AdminListeFournisseursVerres";
import AdminListeFournisseursLentilles from "./components/Admin/AdminListeFournisseursLentilles";
import AdminListeMutuelles from "./components/Admin/AdminListeMutuelles";
import Mentions from "./components/User/Mentions";

import { ToastProvider } from "react-toast-notifications";

function App() {
  const RoutesInner = () => {
    const loggedIn = useSelector((state) => state.login);
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
      // only these paths are accessible without login
      const allowed = [
        "/login",
        "/reset-mdp",
        "/backoffice-login",
      ];
      if (!loggedIn && !allowed.includes(location.pathname)) {
        history.push("/login");
      }
    }, [loggedIn, history, location.pathname]);

    return (
      <div>
        {/** hide nav elements on authentication pages **/}
        {!(location.pathname === "/login" ||
          location.pathname === "/signup" ||
          location.pathname === "/reset-mdp" ||
          location.pathname === "/backoffice-login") && (
          <>
            <Sidebar />
            <TopBar />
          </>
        )}
        <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/magasin/marques" component={Marques} />
            <Route
              path="/magasin/gestion-des-marques"
              component={MarquesFull}
            />
            <Route
              exact
              path="/fournisseurs-montures"
              component={ListeFournisseursMontures}
            />
            <Route
              exact
              path="/fournisseurs-verres"
              component={ListeFournisseursVerres}
            />
            <Route
              exact
              path="/fournisseurs-lentilles"
              component={ListeFournisseursLentilles}
            />
            <Route exact path="/mutuelles" component={ListeMutuelles} />
            <Route
              exact
              path="/fournisseurs-montures/:fournisseurId"
              component={FournisseurMontures}
            />
            <Route
              exact
              path="/fournisseurs-lentilles/:fournisseurId"
              component={FournisseurLentilles}
            />
            <Route
              exact
              path="/fournisseurs-verres/:fournisseurId"
              component={FournisseurVerres}
            />
            <Route
              exact
              path="/mentions"
              component={Mentions}
            />            
            <Route exact path="/mutuelles/:mutuelleId" component={Mutuelle} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={SignUp} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/reset-mdp" component={OubliMdp} />
            <Route exact path="/backoffice-login" component={AdminLogin} />
            <Route exact path="/account" component={MonCompte} />
            <PrivateRoute exact path="/backoffice/home" component={AdminHome} />
            <PrivateRoute
              exact
              path="/admin-fournisseurs-lentilles/:fournisseurId"
              component={AdminFournisseurLentilles}
            />
            <PrivateRoute
              exact
              path="/admin-fournisseurs-montures/:fournisseurId"
              component={AdminFournisseurMontures}
            />
            <PrivateRoute
              exact
              path="/admin-fournisseurs-verres/:fournisseurId"
              component={AdminFournisseurVerres}
            />
            <PrivateRoute
              exact
              path="/mutuelles-admin/:mutuelleId"
              component={AdminMutuelle}
            />
            <PrivateRoute
              exact
              path="/marque-admin/:marqueId"
              component={AdminMarques}
            />
            <PrivateRoute
              exact
              path="/liste-marques-admin"
              component={AdminListeMontures}
            />
            <PrivateRoute
              exact
              path="/liste-fournisseurs-montures"
              component={AdminListeFournisseurs}
            />
            <PrivateRoute
              exact
              path="/liste-fournisseurs-verres"
              component={AdminListeFournisseursVerres}
            />
            <PrivateRoute
              exact
              path="/liste-fournisseurs-lentilles"
              component={AdminListeFournisseursLentilles}
            />
            <PrivateRoute
              exact
              path="/liste-mutuelles-admin"
              component={AdminListeMutuelles}
            />
          </Switch>
        </div>
      );
    };

  return (
    <BrowserRouter>
      <ToastProvider placement="bottom-right">
        <RoutesInner />
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
